/**
 * Payment enums - SOURCE OF TRUTH
 * Pure TypeScript - no Drizzle imports
 */
// Payment status labels
export const paymentStatusLabels = {
    pending: 'Pending',
    paid: 'Paid',
    expired: 'Expired',
    refunded: 'Refunded',
    cancelled: 'Cancelled',
};
export const paymentStatusValues = Object.keys(paymentStatusLabels);
//# sourceMappingURL=payments.js.map